import React, { useEffect, Suspense, lazy, createElement } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { TransformationSection } from './components/TransformationSection';
import { RealResultsSection } from './components/RealResultsSection';
const IncludesSection = lazy(() => import('./components/IncludesSection').then(m => ({
  default: m.IncludesSection
})));
const BonusesSection = lazy(() => import('./components/BonusesSection').then(m => ({
  default: m.BonusesSection
})));
const UrgencyOfferSection = lazy(() => import('./components/UrgencyOfferSection').then(m => ({
  default: m.UrgencyOfferSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  useEffect(() => {
    ReactPixel.init('1308924823976675');
    ReactPixel.pageView();
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = 'ukxbt6i9cor3c23xr4j0lek38bvd3m';
    document.head.appendChild(meta);
    const preconnects = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://cdn.magicpatterns.com'];
    const links: HTMLLinkElement[] = [];
    preconnects.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
      links.push(link);
    });
    return () => {
      document.head.removeChild(meta);
      links.forEach(link => document.head.removeChild(link));
    };
  }, []);
  return <div className="w-full min-h-screen bg-[#2F0240]" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <TransformationSection data-id="element-3" />
      <RealResultsSection data-id="element-4" />

      <Suspense fallback={<div className="min-h-[200px]" data-id="element-6" />} data-id="element-5">
        <IncludesSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <BonusesSection data-id="element-9" />
        <UrgencyOfferSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FooterSection data-id="element-13" />
        <SocialProofPopup data-id="element-14" />
      </Suspense>
    </div>;
}